;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"5A8CXVXtXsCqxI-G6Jwv1"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  /**
   * 에러 이벤트 샘플링
   */
  sampleRate: 1.0,
  /**
   * transaction 이벤트 샘플링
   */
  tracesSampleRate: 0,
});

Sentry.setTag('phase', process.env.NEXT_PUBLIC_PHASE);
Sentry.setTag('layer', 'client');
